
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rankpredictor/cat-percentile-predictor",
      function () {
        return require("private-next-pages/rankpredictor/cat-percentile-predictor.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rankpredictor/cat-percentile-predictor"])
      });
    }
  